<template>

<v-card>

    <not-allowed v-if="!AllowedDisplay"></not-allowed>
    <div v-if="!datas.success && datas.message">{{ datas.filename }} {{ datas.message }}</div>
    <v-btn @click="download" v-if="datas.success" class="primary">{{ datas.filename }}.docx</v-btn>
</v-card>

</template>



<script>
import { client } from '../mixins'; 
    export default {

    name :'publiPostWord',

        mixins : [client],
        
        data: function() {

            return {
                show : false,
                AllowedDisplay : true,
                params : {},
                datas : {},
            }
        },

        computed : {

        },

        watch : {

        },

        methods :  {

            callAPI : function() {
                this.API({type:'post', url:'displaymodule', params:{id:this.idmodule,params:this.params,querys:this.$route.query}}).then((resp) => {
                        this.manageDatas(resp.data)              
                })

            },

            manageDatas(datas) {
                if(!datas.success) {
                        this.AllowedDisplay = false;
                        this.$emit('isloaded',{mod:this.idmodule,'resp':true}); 
                        return false;
                        }
                    this.datas = datas
                    this.show = true 
            },

            download() {
                this.API({type:'post', url:'displaymodule',apidefault:{responseType:'blob'},params:{id:this.idmodule,download:true,params:this.params,querys:this.$route.query}}).then((resp) => {
                    const url = window.URL.createObjectURL(new Blob([resp.data]))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', this.datas.filename+'.docx')
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)             
                })                
            }

        },

        mounted() {


                this.params = this.$store.getters.specificPage(this.modalKey).params
            let getdatas = this.$store.getters.getModuleDatas({page:this.modalKey,id:this.idmodule});
                if(getdatas) {
                    this.manageDatas(getdatas.datas)
                    this.$store.dispatch('removeModuleDatas',{page:this.modalKey,id:this.idmodule})
                } else {
                    this.readDatas() 
                }
        }

    }

</script>